import dayjs from "dayjs";

export function formatDateTime(value: string | null | undefined) {
	if (!value) {
		return "—";
	}
	return dayjs(value).format("DD.MM.YYYY HH:mm");
}

export function formatDate(value: string | null | undefined) {
	if (!value) {
		return "—";
	}
	return dayjs(value).format("DD.MM.YYYY");
}

export function formatNumber(value: number | null | undefined) {
	if (value === null || value === undefined) {
		return "—";
	}
	return value.toLocaleString("uz-UZ");
}

/** Renders an optional field as an em dash when empty. */
export function orDash(value: string | number | null | undefined) {
	if (value === null || value === undefined || value === "") {
		return "—";
	}
	return String(value);
}
